// extracted by mini-css-extract-plugin
module.exports = {"plusButton":"EditorNewlineMenu_plusButton__PNPt8"};